import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  data,
  formData,
  setFormData,
  createInput,
  createSelect,
  updateFee,
  getFeesList,
  deptOptions,
  updating,
  department,
}) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  useEffect(() => {
    setFormData({
      name: _.get(data, 'attributes.name'),
      amount: _.get(data, 'attributes.amount'),
      department: _.get(data, 'attributes.department'),
    });
  }, [data]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateFee(_.get(data, 'id'), formData, () => {
      setModal({ isOpen: false });
      setFormData('');
      getFeesList({ department });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Fee Name' },
              { required: true }
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'amount', label: 'Amount' },
              { required: true }
            )}
          </div>
        </div>
        {Acl(permissions, [`EBPLS FEES SETTING EDIT PLANNING`]) &&
          Acl(permissions, [`EBPLS FEES SETTING EDIT ENGINEERING`]) && (
            <div className="row">
              <div className="col-12 form-group">
                {createSelect(
                  {
                    required: true,
                    placeholder: 'Department',
                    key: 'department',
                    label: 'Department:',
                  },
                  deptOptions
                )}
              </div>
            </div>
          )}
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updateFee: PropTypes.instanceOf(Function).isRequired,
  getFeesList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  deptOptions: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  department: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_FEE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
